<div class="modal-header border-bottom-0 pb-md-0">
  <div class="d-inline-block">
    <h5 class="modal-title d-block text-primary">{{translationPrefix + '.heading' | translate}}</h5>
    <span class="d-block">{{translationPrefix + '.disclaimer' | translate}}</span>
  </div>
  <button (click)="activeModal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body pt-0 mt-3 mt-md-4">
  <ng-container *ngIf="pcpProviders?.items?.length">
    <div
        *ngFor="let item of pcpProviders.items | paginate: {itemsPerPage: pageSize, currentPage: page, totalItems: pcpProviders.total}"
        class="row my-3">
      <div class="col-12">
        <app-pcp-item
            (itemSelected)="emitSelectionMade($event)"
            [pcpInfo]="item"
        ></app-pcp-item>
      </div>
    </div>
    <div class="row mb-3 text-center">
      <div class="col-12">
        <pagination-controls (pageChange)="emitChangePage($event)" class="custom-pagination"></pagination-controls>

      </div>
    </div>
  </ng-container>

  <div *ngIf="pcpProviders === undefined" class="row my-3">
    <div class="col-12 text-center">{{'common.loading' | translate}}</div>
  </div>

  <div *ngIf="pcpProviders !== undefined && (!pcpProviders?.items?.length || !pcpProviders?.total)" class="row my-3">
    <div class="col-12 text-center">{{'common.noDataFound' | translate}}</div>
  </div>


</div>